import { render, staticRenderFns } from "./OverviewPart.vue?vue&type=template&id=1b4d6f78"
import script from "./OverviewPart.vue?vue&type=script&lang=js"
export * from "./OverviewPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports